// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"db342814","297":"a18df913","351":"5a1793f1","355":"4e1534df","456":"7a898a87","495":"cfb63c62","556":"46852413","867":"6f0ba804","891":"570fe381"}[chunkId] + ".chunk.js";
};